import React, { useContext } from "react";
import { Card } from "flowbite-react";
import { AppContext, IAppContextState } from "../../App";
import MainLayout from "../../layout/MainLayout";
import { flowbiteCustomCardThemeConfig } from "../../shared/flowbiteThemeConfig";

import { QuranrtModalData } from "./project-modals/quranrt-modal";
import { HaziraModalData } from "./project-modals/hazira-modal";
import { HishabpatiModalData } from "./project-modals/hishabpati-modal";
import { NexoModalData } from "./project-modals/nexo-modal";
import { BftiModalData } from "./project-modals/bfti-modal";
import { Agency1ModalData } from "./project-modals/agency1-modal";
import { EzazSinglePageModalData } from "./project-modals/ezaz-singlepage-modal";
import { HuntModalData } from "./project-modals/hunt-modal";
import { WarmPawsModalData } from "./project-modals/warmpaws-modal";
import { PlateShareModalData } from "./project-modals/plateshare-modal";
import { GoptsModalData } from "./project-modals/gopts-modal";

function ProjectsPage() {
  const {
    quranrtModalState,
    haziraModalState,
    hishabpatiModalState,
    nexoModalState,
    bftiModalState,
    agency1ModalState,
    ezazSinglePageModalState,
    huntModalState,
    warmPawsModalState,
    plateShareModalState,
    goptsModalState,
  } = useContext<IAppContextState | any>(AppContext);

  const [isOpenQuranrtModal, setOpenQuranrtModal] = quranrtModalState;
  const [isOpenHaziraModal, setOpenHaziraModal] = haziraModalState;
  const [isOpenHishabpatiModal, setOpenHishabpatiModal] = hishabpatiModalState;
  const [isOpenNexoModal, setOpenNexoModal] = nexoModalState;
  const [isOpenBftiModal, setOpenBftiModal] = bftiModalState;
  const [isOpenAgency1Modal, setOpenAgency1Modal] = agency1ModalState;
  const [isOpenEzazSinglePageModal, setOpenEzazSinglePageModal] =
    ezazSinglePageModalState;
  const [isOpenHuntModal, setOpenHuntModal] = huntModalState;
  const [isOpenWarmPawsModal, setOpenWarmPawsModal] = warmPawsModalState;
  const [isOpenPlateShareModal, setOpenPlateShareModal] = plateShareModalState;
  const [isOpenGoptsModal, setOpenGoptsModal] = goptsModalState;

  interface Modal {
    projectTitle: string;
    modalOpenFunction: () => void;
    modalData: React.FC;
    thumbImg: string;
    isModalOpen: boolean;
  }

  const modals: Modal[] = [
    {
      projectTitle: "BFTI - Bangladesh Foreign Trade Institute",
      modalOpenFunction: () => setOpenBftiModal(true),
      modalData: BftiModalData,
      thumbImg: "assets/images/projects/bfti/bfti1.jpg",
      isModalOpen: isOpenBftiModal,
    },
    {
      projectTitle: "GOPTS | Garments Order & Production Tracking System",
      modalOpenFunction: () => setOpenGoptsModal(true),
      modalData: GoptsModalData,
      thumbImg: "assets/images/projects/gopts/gopts-1.jpg",
      isModalOpen: isOpenGoptsModal,
    },
    {
      projectTitle: "Plate Share | Share your foods",
      modalOpenFunction: () => setOpenPlateShareModal(true),
      modalData: PlateShareModalData,
      thumbImg: "assets/images/projects/plateshare/ps1.jpg",
      isModalOpen: isOpenPlateShareModal,
    },
    {
      projectTitle: "WarmPaws - Pet Care in Winter",
      modalOpenFunction: () => setOpenWarmPawsModal(true),
      modalData: WarmPawsModalData,
      thumbImg: "assets/images/projects/warmpaws/wp1.jpg",
      isModalOpen: isOpenWarmPawsModal,
    },
    {
      projectTitle: "Quran Real Translation",
      modalOpenFunction: () => setOpenQuranrtModal(true),
      modalData: QuranrtModalData,
      thumbImg: "assets/images/projects/quranRT/qrt1.jpg",
      isModalOpen: isOpenQuranrtModal,
    },
    {
      projectTitle: "Hazira Web",
      modalOpenFunction: () => setOpenHaziraModal(true),
      modalData: HaziraModalData,
      thumbImg: "assets/images/projects/hazira/hrms1.jpg",
      isModalOpen: isOpenHaziraModal,
    },
    {
      projectTitle: "Hishabpati Web",
      modalOpenFunction: () => setOpenHishabpatiModal(true),
      modalData: HishabpatiModalData,
      thumbImg: "assets/images/projects/hishabpati/hp1.jpg",
      isModalOpen: isOpenHishabpatiModal,
    },
    {
      projectTitle: "Nexo Pet Care",
      modalOpenFunction: () => setOpenNexoModal(true),
      modalData: NexoModalData,
      thumbImg: "assets/images/projects/nexo/nex1.jpg",
      isModalOpen: isOpenNexoModal,
    },
    {
      projectTitle: "Agency Solutions",
      modalOpenFunction: () => setOpenAgency1Modal(true),
      modalData: Agency1ModalData,
      thumbImg: "assets/images/projects/agency1/as1.jpg",
      isModalOpen: isOpenAgency1Modal,
    },
    {
      projectTitle: "Single Page Portfolio",
      modalOpenFunction: () => setOpenEzazSinglePageModal(true),
      modalData: EzazSinglePageModalData,
      thumbImg: "assets/images/projects/ezaz-sp/sp2.jpg",
      isModalOpen: isOpenEzazSinglePageModal,
    },
    {
      projectTitle: "Agency Hunt Homepage",
      modalOpenFunction: () => setOpenHuntModal(true),
      modalData: HuntModalData,
      thumbImg: "assets/images/projects/hunt/hunt4.jpg",
      isModalOpen: isOpenHuntModal,
    },
  ];

  return (
    <MainLayout>
      <div className="mt-5 flex flex-wrap">
        {modals.map((modal, index) => (
          <div
            key={index}
            className="px-3 2xl:w-[25%] lg:w-[33.33%] sm:w-[50%] w-full pb-4"
          >
            <p className="text-gray-200 mb-2 font-medium text-nowrap text-ellipsis overflow-hidden text-[14px]">
              {modal.projectTitle}
            </p>
            <Card
              theme={flowbiteCustomCardThemeConfig}
              onClick={modal.modalOpenFunction}
              className="cursor-pointer relative group"
            >
              <div className="border-2 border-gray-500 rounded-md overflow-hidden aspect-video">
                <img
                  className="rounded-md h-full object-cover w-full"
                  src={modal.thumbImg}
                  alt="Project Thumbnail"
                />
              </div>
              <div className="absolute opacity-0 bg-gray-800 w-full h-full top-0 left-0 group-hover:opacity-15 transition-all"></div>
            </Card>
            {modal.isModalOpen && <modal.modalData />}
          </div>
        ))}
      </div>
    </MainLayout>
  );
}

export default ProjectsPage;
